import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { huntersOverviewUrl } from '../../generic/service/planthunter.service';
import { PlanthunterDetailComponent } from '../../generic/component/planthunter/planthunter.detail.component';

/**
 * A Hunter Detail component used as the base entry point for the KvK Shop '/hunters/detail' route.
 * This component will add the necessary html formatting that is normally set in the site/jsp code.
 * Inside this html the actual planthunter detail will be rendered on the page.
 *
 * @author Patrick van Zadel
 */
@Component({
    selector: 'hunters-detail-component',
    templateUrl: 'hunters.detail.component.html',
    standalone: true,
    imports: [PlanthunterDetailComponent],
})
export class HuntersDetailComponent implements OnInit {
    private route = inject(ActivatedRoute);

    hunterId: string;

    ngOnInit(): void {
        this.hunterId = this.route.snapshot.paramMap.get('plantHunterId');
    }

    getHuntersOverviewUrl(): string {
        return huntersOverviewUrl;
    }
}
